// Who may mark an order / challan / sample as DISPATCHED or DELIVERED.
// Mirrors src/shared/dispatch/access.js — the server enforces the same rule.
//
// Decided by DEPARTMENT, not by workspace access: every BDM holds the
// Inventory and Sales-Operations workspaces, and the old checks here counted
// those as "dispatch team", so BDMs saw (and could press) Mark as Dispatched.

const DISPATCH_DEPARTMENTS = ['dispatch', 'production', 'warehouse', 'logistics', 'store', 'operations'];
const NEVER_DEPARTMENTS = ['sales', 'general_manager', 'accounts'];

export function canMarkDispatch(user: { role?: string | null; department?: string | null } | null | undefined): boolean {
  const role = String(user?.role || '').toLowerCase().trim();
  const dept = String(user?.department || '').toLowerCase().trim();
  if (['superadmin', 'owner'].includes(role)) return true;
  // An Admin counts only outside Sales / GM / Accounts (same as the server).
  if (role === 'admin') return !NEVER_DEPARTMENTS.includes(dept);
  if (DISPATCH_DEPARTMENTS.includes(dept)) return true;
  if (['management', 'operations'].includes(dept)) return true;
  if (role === 'bde' || NEVER_DEPARTMENTS.includes(dept)) return false;
  return false;
}

/**
 * Who may enter, change and SEE the transport AMOUNTS (client, 2026-10-06):
 * Superadmin, Admin and the Department Administrator, whatever their
 * department. The Dispatch team records the transporter, mobile and vehicle
 * but never sees the cost. Mirrors src/shared/dispatch/access.js.
 */
export function canSetTransportAmount(user: { role?: string | null } | null | undefined): boolean {
  return ['admin', 'superadmin', 'department_admin', 'department_administrator'].includes(String(user?.role || '').toLowerCase().trim());
}

/**
 * Who may REVERSE a marked dispatch:
 * Requires Admin, Superadmin, or Department Administrator.
 */
export function canReverseDispatch(user: { role?: string | null } | null | undefined): boolean {
  return ['admin', 'superadmin', 'department_admin', 'department_administrator'].includes(String(user?.role || '').toLowerCase().trim());
}

